import { DialogComponent } from '@theme/dialog';

/**
 * Size guide drawer rendered right after a product's `<variant-picker>`.
 * Opening it marks the size currently selected in the picker; tapping a row selects that
 * size in the picker and closes the drawer.
 */
class MlbSizeGuide extends DialogComponent {
  showDialog() {
    // Until the shopper picks a size (mlb-size-required.js), the checked radio is only Shopify's default: mark no row
    const pending = this.closest('[data-mlb-size-pending]');
    const selected = pending ? undefined : this.#sizeInputs().find((input) => input.checked)?.value;

    for (const row of this.querySelectorAll('[data-value]')) {
      if (!(row instanceof HTMLElement)) continue;
      if (row.dataset.value === selected) {
        row.setAttribute('aria-current', 'true');
      } else {
        row.removeAttribute('aria-current');
      }
    }

    super.showDialog();
  }

  /**
   * Selects the tapped size in the variant picker.
   * @param {MouseEvent} event - Click on a size row; its target is the row button.
   */
  async pick(event) {
    const row = event.target;
    if (!(row instanceof HTMLElement)) return;

    const input = this.#sizeInputs().find((candidate) => candidate.value === row.dataset.value);

    await this.closeDialog();

    // Clicking even the already-selected size records it as the shopper's choice
    input?.click();
  }

  /**
   * The size radios of the variant picker this guide belongs to.
   * @returns {HTMLInputElement[]}
   */
  #sizeInputs() {
    // The guide follows its picker in the markup, after the guide's own module script
    let picker = this.previousElementSibling;
    while (picker && picker.localName !== 'variant-picker') picker = picker.previousElementSibling;
    if (!picker) return [];

    return [...picker.querySelectorAll('.variant-option--size-system input[type="radio"], .variant-option--hat-size input[type="radio"]')].filter(
      (input) => input instanceof HTMLInputElement
    );
  }
}

if (!customElements.get('mlb-size-guide')) customElements.define('mlb-size-guide', MlbSizeGuide);
